import type { AbstractPowerSyncDatabase, PowerSyncBackendConnector, PowerSyncCredentials } from "@powersync/web";
import { api } from "@/auth/session";

// Mirrors the Flutter connector's credential flow: exchange the API token for a
// short-lived PowerSync token (POST /api/v3/powersync/auth).
//
// Writes: v2 does not write through the local CRUD queue yet. Every mutation is
// a direct REST call (see data/mutations.ts) and the change syncs back down.
// So uploadData only has to drain anything unexpected — it never guesses an
// endpoint, which keeps the web from ever sending a malformed write to Rails.
export class RailsConnector implements PowerSyncBackendConnector {
  async fetchCredentials(): Promise<PowerSyncCredentials> {
    const r = await api<{ token: string; expires_at?: string; powersync_url: string }>("/api/v3/powersync/auth", { method: "POST" });
    return { endpoint: r.powersync_url, token: r.token, expiresAt: r.expires_at ? new Date(r.expires_at) : undefined };
  }

  async uploadData(db: AbstractPowerSyncDatabase): Promise<void> {
    const tx = await db.getNextCrudTransaction();
    if (!tx) return;
    console.warn("[v2] discarding unexpected local CRUD ops", tx.crud.map((op) => `${op.op} ${op.table}`));
    await tx.complete();
  }
}
